import type { MenuProps } from 'antd';
import type { TFunction } from 'i18next';

import { SECTION_ICONS, visibleNavigation, type CanViewSection } from '@config/navigation';

export const getSideBarItems = (t: TFunction, canViewSection?: CanViewSection): MenuProps['items'] =>
  visibleNavigation(canViewSection).flatMap((group, index) => {
    const sections = group.sections.map(section => ({
      key: section.path,
      label: t(section.labelKey),
      icon: SECTION_ICONS[section.key],
    }));

    const divider: MenuProps['items'] = index === 0 ? [] : [{ type: 'divider' as const, key: `divider-${group.key}` }];

    return group.labelKey
      ? [...divider, { type: 'group' as const, key: group.key, label: t(group.labelKey), children: sections }]
      : [...divider, ...sections];
  });
